import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

function Datenschutz() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white text-stone-800">
      <header className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md z-40 border-b border-stone-50">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center gap-4">
          <button onClick={() => navigate('/')} className="p-2 hover:bg-stone-50 rounded-full transition-colors group">
            <SafeIcon icon={FiArrowLeft} className="w-5 h-5 text-stone-600 group-hover:text-stone-900" />
          </button>
          <h1 className="text-xl font-light tracking-tight text-stone-900">
            Mind Your Nature
          </h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <h2 className="text-3xl font-light mb-12 text-stone-900">Datenschutzerklärung</h2>

        <div className="space-y-8 font-light text-stone-600 leading-relaxed">
          <div>
            <h5 className="font-medium text-stone-900 mb-3">Datenschutz auf einen Blick</h5>
            <p className="mb-3">Diese Hinweise geben einen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen oder unser Kontaktformular nutzen. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.</p>
            <p className="text-moss-700 font-medium">Diese Website verwendet keine Cookies, keine Tracking-Dienste und keine Analyse-Tools.</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Verantwortliche Stelle</h5>
            <p>
              Nadine Rau u. Mike Trepte GbR<br />
              Bettenhäuserstraße 1<br />
              34123 Kassel<br />
              E-Mail: mike.trepte@underopensky.de<br />
              Telefon: 0561 / 43027276
            </p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Bereitstellung der Website (Netlify / Strato)</h5>
            <p className="mb-2">Die Website wird über den Dienst Netlify bereitgestellt. Netlify, Inc. 2325 3rd Street, Suite 296 San Francisco, CA 94107, USA. Die Domain ist bei Strato in Deutschland registriert; die Auslieferung der Inhalte erfolgt ausschließlich über Netlify.</p>
            <p className="text-stone-500 text-xs">Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren und stabilen Betrieb).</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Datenerfassung über das Kontaktformular (GRETA / Questera)</h5>
            <p>Für das Kontaktformular nutzen wir den Dienst GRETA, ein Produkt des US-Unternehmens Questera.ai. GRETA stellt das Formular und die technische Verarbeitung bereit, um die Daten per Webhook direkt an unser EU-basiertes System (Boost.space) zu übermitteln.</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Zahlungsabwicklung über Stripe</h5>
            <p>Für die Bezahlung unserer Online-Seminare verwenden wir Stripe. Stripe Payments Europe, Ltd. Dublin, Irland. Stripe verarbeitet Name, E-Mail, Rechnungsinformationen und IP-Adresse.</p>
          </div>

          <div className="pt-6 border-t border-stone-200">
            <h5 className="font-medium text-stone-900 mb-3">Ihre Rechte</h5>
            <p className="mb-4">Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch gegen die Verarbeitung und Datenübertragbarkeit.</p>
            <p>Anfragen richten Sie an: <a href="mailto:mike.trepte@underopensky.de" className="text-moss-600 hover:underline">mike.trepte@underopensky.de</a></p>
          </div>

          <div className="pt-4 text-xs text-stone-400">
            Stand: Januar 2026
          </div>
        </div>
      </main>
    </div>
  );
}

export default Datenschutz;